import React from 'react';
import { connect } from 'react-redux';

import { Platform, StyleSheet, View } from 'react-native';
import { setCurrentNote, setReflectionNote } from '../actions';
import { designConstants } from '../../../design/styles';
import strings from '../strings';
import { FloatingInput } from '../../../design/components';
import { withTheme } from '../../../design/styles/useThemeContext';

class NotesSectionContent extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.expanded !== this.props.expanded) {
      console.log('expanded changed!', props.expanded);
      if (props.expanded) {
        this._inputRef && this._inputRef.focus();
      }
    }
  }

  onNoteChanged = (value) => {
    if (this.props.mode === 'dailyreflection') {
      this.props.dispatch(setReflectionNote(value));
    } else {
      this.props.dispatch(setCurrentNote(value));
    }
  };

  render() {
    //We need to set keyboardType: "no-suggestions" and "returnKeyType: "none" on modern samsung devices
    //as it causes app hangs. Details here: https://github.com/facebook/react-native/issues/35155

    const buggySamsung =
      Platform?.constants?.Manufacturer === 'samsung' &&
      Platform?.constants?.Release === '13';
    return (
      <View style={styles.container}>
        <FloatingInput
          ref={(ref) => (this._inputRef = ref)}
          value={this.props.value}
          label={strings.notes_section_hint_label}
          // clearable={true}
          // onClearPress={this.clearMedNotes}
          inputStyle={
            !designConstants.isTablet() &&
            Platform.OS === 'ios' && { minHeight: 106 }
          }
          numberOfLines={5}
          onChangeText={this.onNoteChanged}
          grayBackground
          keyboardType={buggySamsung ? 'no-suggestions' : undefined}
          returnKeyType={buggySamsung ? 'none' : undefined}
          multiline={true}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: designConstants.paddings.paddingBetweenElementsMedium,
    paddingHorizontal: designConstants.paddings.paddingBetweenElementsLarge,
  },
});
const mapStateToProps = (state, props) => {
  if (state.records.current) {
    let note =
      props.mode === 'dailyreflection'
        ? state.records.current?.reflection?.note
        : state.records.current?.record?.note;
    return {
      value: note,
    };
  } else {
    return {
      value: '',
    };
  }
};

NotesSectionContent.defaultProps = {
  value: '',
};

export default connect(mapStateToProps)(withTheme(NotesSectionContent));
